import React, { useEffect } from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { useOnceReveal } from '@common/hooks';

import { GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_option_size_recommendation as PdpOptionSizeRecommendation } from '../graphql/select-option_types.2';
import { useSizeInfoBannerUBL } from '../log/useSizeInfoBannerUBL';

interface Props {
  sizeRecommendation?: PdpOptionSizeRecommendation | null;
  catalogProductId?: string;
}

export const SizeInfoBannerContainer: React.FC<Props> = ({ sizeRecommendation, catalogProductId }) => {
  const { sizeRecommendImpressionUBL } = useSizeInfoBannerUBL();
  const { targetRef, isRevealed } = useOnceReveal();

  // 옵션창 사이즈 추천 노출 로그
  useEffect(() => {
    if (isRevealed && sizeRecommendation && catalogProductId) {
      sizeRecommendImpressionUBL(catalogProductId);
    }
  }, [isRevealed, sizeRecommendation, catalogProductId, sizeRecommendImpressionUBL]);

  if (!sizeRecommendation) {
    return null;
  }

  const { option_recommend_text, option_value } = sizeRecommendation;

  const handleUserFigureClick = () => {
    // const appUrl = config?.appUrl || 'https://zigzag.kr';
    // const url = `${appUrl}/products/${catalog_product_id}/popup?type=${PopupViewType.SIZE_INFO}`;
    // callDeepLink('/simple_browser')({
    //   url: encodeURIComponent(url),
    //   title: '사이즈 정보',
    // });
  };

  return (
    <Wrapper ref={targetRef}>
      <Container onClick={handleUserFigureClick}>
        <TextWrapper>
          <Title as='span' variant='Body_13_Multiline_Medium' color='textPrimary'>
            {option_recommend_text}
          </Title>
          <RecommendSize as='span' variant='Body_13_Multiline_SemiBold' color='subSkyBluePrimary'>
            {option_value}
          </RecommendSize>
        </TextWrapper>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 16px 10px 16px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: ${vars.color.backgroundOnElevated};
  border-radius: 4px;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Title = styled(Text)``;

const RecommendSize = styled(Text)``;
